import { render, staticRenderFns } from "./presentation-ppt-notification.vue?vue&type=template&id=3a17de9e&"
import script from "./presentation-ppt-notification.vue?vue&type=script&lang=js&"
export * from "./presentation-ppt-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports